import {fileDownload} from "@/mixins/file-download";

export const creditBilling = {
  mixins: [ fileDownload ],
  methods: {
    getBillType(value, type) {
      let friendlyName = "";
      let setColor = "";
      switch(value) {
        case 'building':
          friendlyName = 'Building';
          setColor = "#5BccF6";
          break;
        case 'meter':
          friendlyName = 'Meter';
          setColor = "#EF9273";
          break;
      }

      return type === "name" ? friendlyName : setColor;
    },
    stringToSlug(str) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to   = "aaaaeeeeiiiioooouuuunc------";
      for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

      return str;
    },
    getBillState(state, type) {
      let friendlyState = "";
      let stateColor = "";
      switch(state) {
        case 'internal':
          friendlyState = 'Internal Checks';
          stateColor = '#5BccF6';
          break;
        case 'external':
          friendlyState = 'Agent Checks';
          stateColor = 'orange';
          break;
        case 'approved':
          friendlyState = 'Approved';
          stateColor = 'green';
          break;
      }

      return type === "name" ? friendlyState : stateColor;
    },
    async triggerCreditFileDownload(routePath, fileRef, name) {
      const url = "credit-billing/development/" + this.id + "/" + routePath + "/" + fileRef;

      return await this.triggerFileDownload(url, name);
    }
  }
}
